import { render } from "./buttonGroup.vue?vue&type=template&id=4c3a9d54&scoped=true"
import script from "./buttonGroup.vue?vue&type=script&lang=js"
export * from "./buttonGroup.vue?vue&type=script&lang=js"

import "./buttonGroup.vue?vue&type=style&index=0&id=4c3a9d54&scoped=true&lang=css"

import exportComponent from "D:\\Programming_And_Stuff\\Programming\\VueJs\\food-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3a9d54"]])

export default __exports__